function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import BaseBtModal from "../BaseBtModal.vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, requiredIf } from "@vuelidate/validators";
import { sendGAEvent } from "@utils/GaEvents";
import { saveSearchFromRequest } from "@services/realEstateAPI";
import { addGenericRequest } from "@services/requestAPI";
import { sendMortgage } from "@services/agencyAPI";
import { updateNewsletterConsent } from "@services/portfolioCustomerAPI";
import { useKeyEnterPressed } from "@wkComposables/useKeyEnterPressed";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import BaseToggle from "@vueEntry/UIKitComponents/BaseToggle.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { mapActions, mapState } from "pinia";
import { defineComponent } from "vue";
import { useModalStore } from "@store/ModalStore";
import { useLoggedUserStore } from "@store/LoggedUserStore";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
//@ts-ignore
import { PHONE_REGEX } from "@utils/RegexUtils";
import { useMetadataStore } from "@wkWebSrc/js/store";
import md5 from "blueimp-md5";
import { useValidator } from "@wkComposables/useValidator";
import { useCommonVars } from "@wkComposables/useCommonVars";
var phoneValidator = helpers.regex(PHONE_REGEX);
export default defineComponent({
  name: "ContactAgencySuccess",
  components: {
    BaseButton: BaseButton,
    BaseBtModal: BaseBtModal,
    BaseAlert: BaseAlert,
    BaseToggle: BaseToggle,
    BaseInput: BaseInput
  },
  props: {
    activateReloadCb: {
      type: Boolean,
      "default": false
    },
    labels: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      required: true
    },
    showModal: {
      type: Boolean,
      "default": false
    },
    configOptions: {
      type: Object,
      required: true
    },
    data: {
      type: Object
    },
    isContractTypeSale: {
      type: Boolean,
      "default": false
    },
    wikicasaNewsUrl: {
      type: String
    },
    isListing: {
      type: Boolean,
      "default": false
    },
    reopenAfterLogin: {
      type: Boolean,
      "default": false
    },
    name: {
      type: String,
      "default": ""
    },
    franchiseId: {
      type: String,
      "default": ""
    }
  },
  emits: ["reopen-after-login", "show-success-request-sent", "show-error-modal", "closed-modal"],
  setup: function setup() {
    var _useKeyEnterPressed = useKeyEnterPressed(),
      enterPressedCb = _useKeyEnterPressed.enterPressedCb,
      onEnterPressed = _useKeyEnterPressed.onEnterPressed;
    var _useValidator = useValidator(),
      isValid = _useValidator.isValid;
    var _useCommonVars = useCommonVars(),
      wkLabels = _useCommonVars.wkLabels;
    return {
      v$: useVuelidate(),
      enterPressedCb: enterPressedCb,
      onEnterPressed: onEnterPressed,
      isValid: isValid,
      wkLabels: wkLabels
    };
  },
  data: function data() {
    return {
      show: false,
      requestData: {
        toggleGeneric: false,
        toggleMortgage: false,
        phone: "",
        name: "",
        toggleSearch: false,
        toggleNews: false
      },
      isLoading: false,
      isValidPhone: null,
      showRequestSentOk: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({
    showSaveSearch: function showSaveSearch() {
      return this.configOptions ? this.configOptions.showSaveSearch : true;
    },
    showGenericRequest: function showGenericRequest() {
      return this.configOptions ? this.configOptions.showGenericRequest : true;
    },
    isFranchiseToExclude: function isFranchiseToExclude() {
      var franchiseId = Number(this.franchiseId);
      if (isNaN(franchiseId)) return false;
      return franchiseId === 9 || franchiseId === 13 || franchiseId === 58;
    },
    isTecnocasaFranchise: function isTecnocasaFranchise() {
      var franchiseId = Number(this.franchiseId);
      if (isNaN(franchiseId)) return false;
      return franchiseId === 8 || franchiseId === 57;
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, {
    userEmailFromStore: "email",
    userNameFromStore: "name"
  })), mapState(usePublicUserMenuStore, ["publicUserId"])), mapState(useMetadataStore, ["pageName", "location"])),
  created: function created() {
    this.show = this.showModal;
    this.setLocation("Modale contatta agenzia (step 2)");
    //Pre-compiling the phone field!
    this.requestData.name = this.isUserLogged ? this.userNameFromStore : this.name || "";
    this.requestData.phone = this.data.phone || "";
    this.onEnterPressed(this.submitForm);
  },
  mounted: function mounted() {
    if (this.reopenAfterLogin) {
      this.requestData.toggleSearch = true;
    }
  },
  methods: Object.assign(Object.assign({
    handleMortgageRequest: function handleMortgageRequest(data) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var price, phone, params;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(!this.requestData.toggleMortgage || !((_a = this.data) === null || _a === void 0 ? void 0 : _a.sale))) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              price = Number(data.price.split(".").join("")); //The incoming data in provided by the parent modal (ContactAgencyModal) and it can contain the phone number if the phone field has been filled
              //But, if that is not the case, then we have to retrieve the phone number that we got in the current form
              phone = data.phone || this.requestData.phone;
              params = {
                name: data.name || this.userNameFromStore,
                email: data.email || this.userEmailFromStore,
                phone: phone,
                reLink: data.canonicalURL,
                realEstateID: data.id,
                rePrice: price,
                tenant: 1
              };
              sendGAEvent("mortgage", {
                event_location: "".concat(this.pageName, " - ").concat(this.location)
              });
              _context.next = 9;
              return sendMortgage(params);
            case 9:
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 11]]);
      }));
    },
    handleSearchRequest: function handleSearchRequest(data) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var email, searchBean, price, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.requestData.toggleSearch) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              email = data.email || this.userEmailFromStore;
              searchBean = {};
              searchBean["macroTypologyId"] = data.macroTypology;
              searchBean["typologyId"] = data.typology;
              searchBean["cityId"] = data.city;
              searchBean["sale"] = data.sale;
              searchBean["rent"] = !data.sale; //TODO: chideere se è sempre così dato che vi è la prop rent...
              price = parseFloat(data.price.replace(".", ""));
              if (price) {
                searchBean["priceFrom"] = Math.round(price * 0.8);
                searchBean["priceTo"] = Math.round(price * 1.2);
              }
              _context2.prev = 11;
              sendGAEvent("mail_alert_save", {
                event_location: "".concat(this.pageName, " - ").concat(this.location),
                real_estate_place_id: (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.placeID) !== null && _b !== void 0 ? _b : null
              });
              _context2.next = 15;
              return saveSearchFromRequest(email, searchBean);
            case 15:
              _context2.next = 25;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](11);
              response = _context2.t0.response;
              if (!response) {
                _context2.next = 25;
                break;
              }
              if (!(response.status !== 401 && response.status !== 405 && response.status !== 409 && response.status !== 412)) {
                _context2.next = 24;
                break;
              }
              console.error(_context2.t0.message);
              return _context2.abrupt("return");
            case 24:
              //Sending the response status, so it can be handled by the parent component
              this.showErrorModal(response.status);
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[11, 17]]);
      }));
    },
    handleGenericRequest: function handleGenericRequest(data) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              if (this.requestData.toggleGeneric) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              sendGAEvent("generic_request_lead", {
                event_location: "".concat(this.pageName, " - ").concat(this.location),
                real_estate_place_id: (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.placeID) !== null && _b !== void 0 ? _b : null,
                real_estate_contract_type: ((_c = this.data) === null || _c === void 0 ? void 0 : _c.rent) ? "rent" : "sale",
                real_estate_typology_name: (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.typologyName) !== null && _e !== void 0 ? _e : null,
                real_estate_typology_id: (_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.typology) !== null && _g !== void 0 ? _g : null,
                user_email_hashed: md5(data.email || this.userEmailFromStore),
                user_email: data.email || this.userEmailFromStore,
                user_id: this.publicUserId === -1 ? null : this.publicUserId
              });
              _context3.next = 6;
              return addGenericRequest({
                agencyId: data.agencyId,
                realEstateId: data.id || -1,
                name: this.requestData.name || data.name,
                email: data.email,
                typologyId: (_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h.typology) !== null && _j !== void 0 ? _j : null,
                phone: data.phone || this.requestData.phone,
                notes: data.notes
              });
            case 6:
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 8]]);
      }));
    },
    catchEmittedMortgageToggle: function catchEmittedMortgageToggle(emittedValue) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              setTimeout(function () {
                var _a;
                if (emittedValue) {
                  (_a = document.getElementById("phone")) === null || _a === void 0 ? void 0 : _a.focus();
                }
              }, 200);
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
    },
    checkIfValidPhone: function checkIfValidPhone() {
      var validPhone = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
      this.isValidPhone = validPhone.test(this.requestData.phone);
      return this.isValidPhone;
    },
    handleNewsRequest: function handleNewsRequest(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var email;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.requestData.toggleNews) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              email = data.email || this.userEmailFromStore;
              _context5.prev = 3;
              sendGAEvent("newsletter_subscribe", {
                event_location: "".concat(this.pageName, " - ").concat(this.location)
              });
              _context5.next = 7;
              return updateNewsletterConsent(email);
            case 7:
              _context5.next = 12;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](3);
              console.error(_context5.t0);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[3, 9]]);
      }));
    },
    submitForm: function submitForm() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data, promises;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.isLoading) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", false);
            case 2:
              this.v$.$touch(); //Touching all fields!
              if (!this.v$.$invalid) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return", false);
            case 5:
              data = this.data;
              promises = Promise.all([this.handleMortgageRequest(data), this.handleSearchRequest(data), this.handleGenericRequest(data), this.handleNewsRequest(data)]);
              _context6.prev = 7;
              this.isLoading = true;
              _context6.next = 11;
              return promises;
            case 11:
              _context6.next = 17;
              break;
            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](7);
              console.error(_context6.t0);
              return _context6.abrupt("return", false);
            case 17:
              _context6.prev = 17;
              this.$emit("reopen-after-login", false);
              this.$emit("show-success-request-sent", true);
              this.show = false;
              this.isLoading = false;
              return _context6.finish(17);
            case 23:
              return _context6.abrupt("return", true);
            case 24:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[7, 13, 17, 23]]);
      }));
    },
    showErrorModal: function showErrorModal(errorCode) {
      this.$emit("show-error-modal");
      return errorCode;
    },
    onClosed: function onClosed() {
      this.$emit("closed-modal");
    },
    openWikiPrivacy: function openWikiPrivacy() {
      var privacyUrl = "/privacy/#informativa-j";
      window.open(privacyUrl, "_blank", "scrollbars=yes, width=550, height=600");
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useMetadataStore, ["setLocation"])),
  validations: function validations() {
    var _this = this;
    return {
      requestData: {
        name: {
          required: requiredIf(function () {
            return _this.requestData.toggleMortgage;
          })
        },
        phone: {
          //The required validator is required to activate the red star which marks an input as required!
          required: requiredIf(function () {
            return _this.requestData.toggleMortgage;
          }),
          isPhoneValid: function isPhoneValid(phoneNumber) {
            return !_this.requestData.toggleMortgage || phoneValidator(phoneNumber);
          }
        }
      }
    };
  }
});